import React from "react";
import { FC } from "react";
import { useMemo } from "react";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import { FormRenderProps } from "react-final-form";
import { useField } from "react-final-form";
import { useQuery } from "react-query";
import Typography from "@material-ui/core/Typography";
import Button from "../../../../../components/Button";
import Autocomplete from "../../../../../components/Autocomplete";
import Field from "../../../../../components/Field";
import Loading from "../../../../../components/Loading";
import { mutateErrors } from "../../../../../utils";
import Error from "../../../../../components/Error";
import useSchoolQueries from "../../../../school/hooks/useSchoolQueries";
import DegreeField from "../../../../degree/components/DegreeField";
import { useUserAccount } from "../../context";

const useStyles = makeStyles((theme: Theme) => ({
  field: {
    marginBottom: theme.spacing(2),
  },
}));

const SchoolRoleForm: FC<FormRenderProps> = ({ handleSubmit, submitting }) => {
  const classes = useStyles();

  const {
    input: { value },
  } = useField("role");
  const {
    profile: {
      data: { data: profile },
    },
  } = useUserAccount();

  const roles = useMemo(
    () => [
      {
        id: 0,
        name: "Admin",
      },
      {
        id: 1,
        name: "Manager",
      },
    ],
    [],
  );

  if (!profile.school) {
    return null;
  }

  return (
    <>
      <form onSubmit={handleSubmit}>
        <Field
          fullWidth
          className={classes.field}
          name="role"
          placeholder="Role"
          label={
            <Typography variant={"h4"} color={"primary"}>
              Select Role
            </Typography>
          }
          options={roles}
          clear={"true"}
          component={Autocomplete}
        />
        {value && value.id === 1 && (
          <>
            <BranchesArray />
            <DegreeField
              size={"small"}
              fullWidth
              name="degrees"
              multiple={true}
              label={
                <Typography variant={"h4"} color={"primary"}>
                  Select Degrees
                </Typography>
              }
              placeholder="Degree"
              className={classes.field}
            />
          </>
        )}
        <Button
          type="submit"
          color="secondary"
          variant="contained"
          disabled={submitting}
        >
          Save
        </Button>
      </form>
    </>
  );
};

export default React.memo(SchoolRoleForm);

function BranchesArray() {
  const classes = useStyles();
  const {
    profile: {
      data: { data: profile },
    },
  } = useUserAccount();

  const { fetchSchoolBranches } = useSchoolQueries();
  const { isLoading, isFetching, isError, error, data } = useQuery<any>(
    `school_${profile.school.id}_branches`,
    () => fetchSchoolBranches(profile.school.id),
  );

  if (isLoading || isFetching) {
    return <Loading />;
  }

  if (isError) {
    const { message } = mutateErrors(error);
    return <Error text={message} />;
  }

  return (
    <Field
      fullWidth
      className={classes.field}
      multiple={true}
      size={"small"}
      name="branches"
      placeholder="Branches"
      label={
        <Typography variant={"h4"} color={"primary"}>
          Select Branches
        </Typography>
      }
      options={data.data}
      clear={"true"}
      component={Autocomplete}
    />
  );
}
